export default class InputTarget {
    constructor(element) {
        this.$element = $(element);
        this.$target = $(this.$element.data('target'));
    }

    init() {
        this.$element.on('change.inputTarget', () => {
            this.$target.val(this.$element.val());
        });
    }
}